import declint from '../../utils/declint';
import { templateParser } from '../../utils/formatString';

/** Замена подстроки в строке */
const replaceSubstring = (string, keyword, replaced) => {
  if (typeof string === 'string') {
    return string.replace(keyword, replaced);
  }
  return string;
};

/** Создает массив заданной длины и наполняет его числами от 1 до length */
const getIntegerArray = (length) => Array
  .from(Array(length), (_, index) => index);

/** Создает массив чисел с заданным шагом */
const getSliderSteps = (array, step) => array.map((elem) => elem * step);

const getDefaultIndex = ({ sliderSteps, limit, isSwitchChecked, value }) => {
  if (isSwitchChecked) {
    return sliderSteps.length - 1;
  }

  return sliderSteps.indexOf(value ?? limit);
};

const getInvitedCtns = (persons = []) => persons.map((person) => person.ctn);

const isCtnConnected = (cellNumbers = [], target) => cellNumbers.some((number) => number === target);

// eslint-disable-next-line arrow-body-style
const getAccumulatorNames = (accumulators = []) => accumulators.reduce((acc, elem) => {
  return { ...acc, [elem.name]: elem.limit };
}, {});

const replaceObjectKeys = (obj, newKeys) => {
  const resultObj = {};

  // eslint-disable-next-line no-unused-vars
  for (const key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      if (newKeys[key]) {
        resultObj[newKeys[key]] = obj[key];
      } else {
        resultObj[key] = obj[key];
      }
    }
  }
  return resultObj;
};

const getInstallationLimits = (newLimits, accumulators) => {
  const defaultLimits = getAccumulatorNames(accumulators);

  return Object.keys(newLimits).reduce((acc, name) => {
    if (newLimits[name] === defaultLimits[name]) {
      return acc;
    }
    return { ...acc, [name]: newLimits[name] };
  }, {});
};

const sharingDescription = (description, count, maxCount) => {
  const amountOfNumbersText = declint(
    count,
    ['номером', 'номерами', 'номерами'],
  );

  const availableAmountToConnect = declint(
    maxCount,
    ['возможного', 'возможных', 'возможных'],
  );

  return templateParser(description, {
    COUNT: count,
    MAXCOUNT: maxCount,
    DECLINT: amountOfNumbersText,
    AVAILABLE: availableAmountToConnect,
  });
};

const transformAccordionData = (section = []) => section.map((question) => ({
  title: question.title,
  content: {
    description: question.description,
  },
}));

export {
  replaceSubstring,
  getDefaultIndex,
  getInvitedCtns,
  isCtnConnected,
  getIntegerArray,
  getSliderSteps,
  getAccumulatorNames,
  replaceObjectKeys,
  getInstallationLimits,
  sharingDescription,
  transformAccordionData,
};
